import api from './api';

// جلب جميع المرشدين (للوحة التحكم)
export const getTourGuides = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/tour-guides/admin/all?${queryParams}`);
  return response.data;
};

// جلب المرشدين المتاحين (للتخصيص)
export const getAvailableTourGuides = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/tour-guides?${queryParams}`);
  return response.data;
};

// جلب مرشد معين بالـ ID
export const getTourGuideById = async (id) => {
  const response = await api.get(`/tour-guides/${id}`);
  return response.data;
};

// جلب مرشد بالـ slug
export const getTourGuideBySlug = async (slug) => {
  const response = await api.get(`/tour-guides/slug/${slug}`);
  return response.data;
};

// جلب المرشدين المتاحين في منطقة معينة
export const getAvailableTourGuidesByArea = async (area, date = null) => {
  const url = date ? `/tour-guides/available/${area}?date=${date}` : `/tour-guides/available/${area}`;
  const response = await api.get(url);
  return response.data;
};

// إنشاء مرشد جديد
export const createTourGuide = async (data) => {
  const response = await api.post('/tour-guides', data);
  return response.data;
};

// تحديث مرشد
export const updateTourGuide = async (id, data) => {
  const response = await api.put(`/tour-guides/${id}`, data);
  return response.data;
};

// تحديث حالة المرشد
export const updateTourGuideStatus = async (id, status, reason = '') => {
  const response = await api.patch(`/tour-guides/${id}/status`, { status, reason });
  return response.data;
};

// تسجيل دفعة لمرشد
export const getTourGuideStats = async (id) => {
  const response = await api.get(`/performance/tour-guides/${id}/stats`);
  return response.data;
};

export const recordTourGuidePayment = async (id, paymentData) => {
  const response = await api.post(`/performance/tour-guides/${id}/payments`, paymentData);
  return response.data;
};

// حذف مرشد
export const deleteTourGuide = async (id) => {
  const response = await api.delete(`/tour-guides/${id}`);
  return response.data;
};

// جلب تقييمات مرشد
export const getTourGuideReviews = async (id) => {
  const response = await api.get(`/tour-guides/${id}/reviews`);
  return response.data;
};

// إضافة تقييم لمرشد (من العميل)
export const addTourGuideReview = async (id, reviewData) => {
  const response = await api.post(`/tour-guides/${id}/reviews`, reviewData);
  return response.data;
};

// تحديث تقييم مرشد (للأدمن)
export const updateTourGuideReview = async (guideId, reviewId, data) => {
  const response = await api.put(`/tour-guides/${guideId}/reviews/${reviewId}`, data);
  return response.data;
};
